import React from "react";
import "./Services.css";
import { BsCheck2 } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import i18n from "../../languages/i18n";

const Services = () => {
  const { t } = useTranslation();
  return (
    <section id="services">
      <h5 className={i18n.language == "ar" && "arabicText "}>
        {t("serviceSection.offer_title")}
      </h5>
      <h2 className={i18n.language == "ar" && "arabicText "}>
        {t("serviceSection.services_title")}
      </h2>
      <div className="container services_container">
        {/* UI/UX card */}
        <div className="service" data-aos="fade-right" data-aos-duration="1500">
          <div className="service_head">
            <h3 className={i18n.language == "ar" && "arabicText"}>
              {t("serviceSection.modile_dev_title")}{" "}
            </h3>
          </div>
          <ul className="service_list">
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Android and IOS</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Requirement Analysis</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Conception</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Coding & deployement</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Maintenance</p>
            </li>

            <li>
              <BsCheck2 className="service_list-icon" />
              <p>
                Framework: <strong>React-native</strong>
              </p>
            </li>
          </ul>
        </div>
        {/* End of UI/UX card */}
        {/* UI/UX card */}
        <div className="service" data-aos="fade-right" data-aos-duration="1500">
          <div className="service_head">
            <h3 className={i18n.language == "ar" && "arabicText "}>
              {t("serviceSection.web_dev_title")}
            </h3>
          </div>
          <ul className="service_list">
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Frontend & Backend</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Dynamic web app</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Static web app</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Multi-language support</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Responsive design</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>
                Framework: <strong>ReactJS</strong>
              </p>
            </li>
          </ul>
        </div>
        {/* End of UI/UX card */}
        {/* UI/UX card */}
        <div className="service" data-aos="fade-right" data-aos-duration="1500">
          <div className="service_head">
            <h3 className={i18n.language == "ar" && "arabicText "}>
              {t("serviceSection.content_title")}
            </h3>
          </div>
          <ul className="service_list">
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Graphic design</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Video editing</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Social Media</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Email management</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Blog Posts</p>
            </li>
            <li>
              <BsCheck2 className="service_list-icon" />
              <p>Online Courses</p>
            </li>
          </ul>
        </div>
        {/* End of UI/UX card */}
      </div>
    </section>
  );
};

export default Services;
